import * as CookieConsent from 'Vendor/vanilla-cookieconsent/src/cookieconsent.js';

/*
 * Pure lightweight vanilla script so we can't use an ES6 pattern for this.
 * Requires "./src/vendor/vanilla-cookieconsent/dist/cookieconsent.js" to be bundled together with this file.
 * https://github.com/orestbida/cookieconsent
 * https://orestbida.com/demo-projects/cookieconsent/
 */

window.addEventListener('load', function () {

    // TODO: add class on open, remove on close

    // Add custom theme to body
    document.querySelector('body').classList.add('cookieconsent-theme');

    // obtain cookieconsent plugin
    var cookieconsent = initCookieConsent();
    
    fetch('/umbraco/Furillo/EditorsApi/GetCookieConsentConfig?host=' + window.location.host).then(function (config) {
        return config.json();
    }).then(function (json) {

        cookieconsent.run({
            autorun: true,
            auto_language: 'document',
            autoclear_cookies: true,
            page_scripts: true,
            hide_from_bots: true,
            gui_options: {
                consent_modal: {
                    layout: 'cloud',               // box/cloud/bar
                    position: 'bottom center',     // bottom/middle/top + left/right/center
                    transition: 'slide',           // zoom/slide
                    swap_buttons: false            // enable to invert buttons
                },
                settings_modal: {
                    layout: 'box',                 // box/bar
                    // position: 'left',           // left/right
                    transition: 'slide'            // zoom/slide
                }
            },

            onFirstAction: function (user_preferences, cookie) {
                // callback triggered only once
            },

            onAccept: function (cookie) {
                // ... cookieconsent accepted
            },

            onChange: function (cookie, changed_preferences) {
                // ... cookieconsent preferences were changed
            },

            languages: json
        });


    }).catch(function (err) {
        console.warn('Something went wrong when initiating Cookie Consent.', err);
    });



    // run plugin with config object
    //cookieconsent.run({
    //    autorun: true,
    //    auto_language: 'document',
    //    autoclear_cookies: true,
    //    page_scripts: false,
    //    gui_options: {
    //        consent_modal: {
    //            layout: 'cloud',               // box/cloud/bar
    //            position: 'bottom center',     // bottom/middle/top + left/right/center
    //            transition: 'slide',           // zoom/slide
    //            swap_buttons: false            // enable to invert buttons
    //        },
    //        settings_modal: {
    //            layout: 'box',                 // box/bar
    //            // position: 'left',           // left/right
    //            transition: 'slide'            // zoom/slide
    //        }
    //    },

    //    onFirstAction: function (user_preferences, cookie) {
    //        // callback triggered only once
    //    },

    //    onAccept: function (cookie) {
    //        // ... cookieconsent accepted
    //    },

    //    onChange: function (cookie, changed_preferences) {
    //        // ... cookieconsent preferences were changed
    //    },

    //    languages: {
    //        sv: {
    //            consent_modal: {
    //                title: 'Din integritet är viktig för oss',
    //                description: 'Vår webplats använder cookies och tredjepartstjänster för att förbättra innehåll och funktionalitet genom att analysera trafik. Du kan välja att tillåta alla eller läsa mer, och välja vilka cookies vi får använda, genom att klicka på inställningar.',
    //                primary_btn: {
    //                    text: 'Tillåt alla',
    //                    role: 'accept_all'              // 'accept_selected' or 'accept_all'
    //                },
    //                secondary_btn: {
    //                    text: 'Inställningar',
    //                    role: 'settings'                // 'settings' or 'accept_necessary'
    //                }
    //            },
    //            settings_modal: {
    //                title: 'Information och inställningar',
    //                save_settings_btn: 'Tillåt mitt urval',
    //                accept_all_btn: 'Tillåt alla',
    //                reject_all_btn: 'Avvisa alla',       // optional, [v.2.5.0 +]
    //                cookie_table_headers: [
    //                    { col1: 'Namn' },
    //                    { col2: 'Domän' },
    //                    { col3: 'Utgår' },
    //                    { col4: 'Beskrivning' },
    //                    { col5: 'Typ' }
    //                ],
    //                blocks: [
    //                    {
    //                        title: 'Användning av cookies',
    //                        description: 'Vi använder cookies för att säkerställa grundläggande funktionalitet samt förhöja din upplevelse av vår webplats. Du kan välja att tillåta alla eller själv välja vilka kategorier du vill tillåta oss att använda.'
    //                    }, {
    //                        title: 'Nödvändiga',
    //                        description: 'Dessa cookies är nödvändiga för att webplatsen ska fungera som tänkt. Utan dessa skulle inte webplatsen fungera och det går därför inte heller att välja bort denna kategori. Information i dessa cookies används aldrig utanför denna webplats.',
    //                        toggle: {
    //                            value: 'necessary',
    //                            enabled: true,
    //                            readonly: true
    //                        },
    //                        cookie_table: [
    //                            {
    //                                col1: 'cc_cookie',
    //                                col2: window.location.host,
    //                                col3: '6 månader',
    //                                col4: 'Används för att spara de inställningar ni gjort gällande cookies på vår webplats.',
    //                                col5: 'Persisterad'
    //                            }]
    //                    }, {
    //                        title: 'Statistik',
    //                        description: 'Cookies för statistik hjälper en oss att förstå hur besökare interagerar med vår webplats genom att samla och rapportera in information anonymt. Genom att analysera denna information kan vi förbättra vårt innehåll och våra funktioner.',
    //                        toggle: {
    //                            value: 'analytics',
    //                            enabled: true,
    //                            readonly: false
    //                        },
    //                        cookie_table: [
    //                            {
    //                                col1: '^_ga',
    //                                col2: 'google.com',
    //                                col3: '2 years',
    //                                col4: 'description ...',
    //                                col5: 'Permanent cookie',
    //                                is_regex: true
    //                            },
    //                            {
    //                                col1: '_gid',
    //                                col2: 'google.com',
    //                                col3: '1 day',
    //                                col4: 'description ...',
    //                                col5: 'Permanent cookie'
    //                            }
    //                        ]
    //                    }, {
    //                        title: 'Marknadsföring',
    //                        description: 'Cookies för marknadsföring används av tredjepartsleverantörer för att spåra besökare på webplatser med avsikt att skräddarsy relevanta och engagerande annonser för enskilda användare.',
    //                        toggle: {
    //                            value: 'marketing',
    //                            enabled: true,
    //                            readonly: false
    //                        },
    //                        cookie_table: [
    //                            {
    //                                col1: '?',
    //                                col2: 'google.com',
    //                                col3: '?',
    //                                col4: '?',
    //                                col5: '?',
    //                                is_regex: true
    //                            },
    //                            {
    //                                col1: '?',
    //                                col2: 'youtube.com',
    //                                col3: '?',
    //                                col4: '?',
    //                                col5: '?'
    //                            }
    //                        ]
    //                    }, {
    //                        title: 'Mer information',
    //                        description: 'Om ni har några funderingar, eller vill veta mer, om vår policy kring cookies och GDPR kan ni läsa mer och hitta kontaktinformation på vår sida <a class="cc-link" href="#yourwebsite">om cookies</a>.',
    //                    }
    //                ]
    //            }
    //        },
    //        en: {
    //            consent_modal: {
    //                title: 'I use cookies',
    //                description: 'Hi, this website uses essential cookies to ensure its proper operation and tracking cookies to understand how you interact with it. The latter will be set only upon approval. <a aria-label="Cookie policy" class="cc-link" href="#">Read more</a>',
    //                primary_btn: {
    //                    text: 'Accept',
    //                    role: 'accept_all'              // 'accept_selected' or 'accept_all'
    //                },
    //                secondary_btn: {
    //                    text: 'Settings',
    //                    role: 'settings'                // 'settings' or 'accept_necessary'
    //                }
    //            },
    //            settings_modal: {
    //                title: 'Cookie preferences',
    //                save_settings_btn: 'Save settings',
    //                accept_all_btn: 'Accept all',
    //                reject_all_btn: 'Reject all',       // optional, [v.2.5.0 +]
    //                cookie_table_headers: [
    //                    { col1: 'Name' },
    //                    { col2: 'Domain' },
    //                    { col3: 'Expiration' },
    //                    { col4: 'Description' },
    //                    { col5: 'Type' }
    //                ],
    //                blocks: [
    //                    {
    //                        title: 'Cookie usage',
    //                        description: 'I use cookies to ensure the basic functionalities of the website and to enhance your online experience. You can choose for each category to opt-in/out whenever you want.'
    //                    }, {
    //                        title: 'Strictly necessary cookies',
    //                        description: 'These cookies are essential for the proper functioning of my website. Without these cookies, the website would not work properly.',
    //                        toggle: {
    //                            value: 'necessary',
    //                            enabled: true,
    //                            readonly: true
    //                        }
    //                    }, {
    //                        title: 'Analytics cookies',
    //                        description: 'These cookies collect information about how you use the website, which pages you visited and which links you clicked on. All of the data is anonymized and cannot be used to identify you.',
    //                        toggle: {
    //                            value: 'analytics',
    //                            enabled: false,
    //                            readonly: false
    //                        },
    //                        cookie_table: [
    //                            {
    //                                col1: '^_ga',
    //                                col2: 'google.com',
    //                                col3: '2 years',
    //                                col4: 'description ...',
    //                                col5: 'Permanent cookie',
    //                                is_regex: true
    //                            },
    //                            {
    //                                col1: '_gid',
    //                                col2: 'google.com',
    //                                col3: '1 day',
    //                                col4: 'description ...',
    //                                col5: 'Permanent cookie'
    //                            }
    //                        ]
    //                    }, {
    //                        title: 'More information',
    //                        description: 'For any queries in relation to my policy on cookies and your choices, please <a class="cc-link" href="#yourwebsite">contact me</a>.',
    //                    }
    //                ]
    //            }
    //        }
    //    }
    //});



});